import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import { loggedInUser } from "../utils/store";
const PaymentSuccess = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  return (
    <section className="container">
      <div className="row justify-content-center align-items-center vh-100">
        <div className="col-md-5 col-12">
          <div className="shadow text-center card">
            <div className="card-body">
              <h1>Thank You</h1>
              <h2 className="mb-4">
                You have successfully subscribed the package
              </h2>
              <Link to="/" className="btn btn-primary">
                Go Back Homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentSuccess;
